import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import {
  UIButton,
  UIPaginationBar,
} from "../../../components/ui";
import TeamToolbar from "../../Company-portal/TeamsPermissions/TeamToolbar";
import EmployeesTable from "../../Company-portal/TeamsPermissions/EmployeesTable";
import DeleteEmployeeModal from "../../Company-portal/TeamsPermissions/DeleteEmployeeModal";
import TeamListEmptyState from "../../Company-portal/TeamsPermissions/TeamListEmptyState";
import useAdminCompanyEmployeesList from "./hooks/useAdminCompanyEmployeesList";

const AdminEmployeesManagement = ({ companyId }) => {
  const {
    copy,
    employeesCopy,
    search,
    debouncedSearch,
    rows,
    page,
    pageSize,
    pages,
    rangeFrom,
    rangeTo,
    total,
    isLoading,
    employeeToDelete,
    pageSizeOptions,
    canAdd,
    canEdit,
    canDelete,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    handleAddEmployee,
    handleViewEmployee,
    handleEditEmployee,
    handleRemove,
    closeDeleteModal,
    confirmDeleteEmployee,
  } = useAdminCompanyEmployeesList(companyId);

  if (isLoading && !rows.length) {
    return null;
  }

  return (
    <Box className="team-management__panel">
      <TeamToolbar
        search={search}
        searchPlaceholder={employeesCopy.searchPlaceholder}
        onSearchChange={handleSearchChange}
      >
        {canAdd && (
          <UIButton
            variant="outlined"
            size="large"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddEmployee}
            className="team-management__add"
          >
            {employeesCopy.addEmployee}
          </UIButton>
        )}
      </TeamToolbar>

      {rows.length ? (
        <>
          <EmployeesTable
            rows={rows}
            pageSize={pageSize}
            labels={employeesCopy.table}
            onView={handleViewEmployee}
            onEdit={handleEditEmployee}
            onRemove={handleRemove}
            canEdit={canEdit}
            canDelete={canDelete}
          />
          <UIPaginationBar
            currentPage={page}
            pages={pages}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            rangeTemplate={employeesCopy.rangeTemplate}
            rangeFrom={rangeFrom}
            rangeTo={rangeTo}
            rangeTotal={total}
            rowsPerPageLabel={copy.rowsPerPageLabel}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      ) : (
        <TeamListEmptyState
          searchTerm={debouncedSearch}
          total={total}
          copy={employeesCopy}
          canAdd={canAdd}
          actionLabel={employeesCopy.addEmployee}
          onAction={handleAddEmployee}
        />
      )}

      <DeleteEmployeeModal
        open={Boolean(employeeToDelete)}
        employee={employeeToDelete}
        copy={employeesCopy.deleteModal}
        onClose={closeDeleteModal}
        onConfirm={confirmDeleteEmployee}
      />
    </Box>
  );
};

AdminEmployeesManagement.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AdminEmployeesManagement;
